import * as React from 'react';
import { Segment, Grid, Container, Header, List, Icon, SemanticICONS } from 'semantic-ui-react';
import { HashLink } from 'react-router-hash-link';
import { menuItems } from './MenuItems';

export const Footer = (props: any) =>
  <Segment inverted vertical style={{ padding: '5em 0em' }}>
    <Container>
      <Grid columns='equal' divided inverted stackable>
        <Grid.Row>
          <Grid.Column>
            <Header inverted as='h4' content='Company' />
            <List link inverted>
              {
                menuItems.company.map(i => 
                  <List.Item key={i.label} as={HashLink} smooth to={i.url}>{i.label}</List.Item>)
              }
            </List>
          </Grid.Column>

          <Grid.Column>
            <Header inverted as="h4" content='Social' />            
            <List link inverted>
              <List.Item as='a' href='https://twitter.com/LonchNow'><Icon name='twitter'/>Twitter</List.Item>
              <List.Item as='a' href='https://medium.com/@lonchnow'><Icon name='medium'/> Medium</List.Item>
              <List.Item as='a' href='https://www.facebook.com/LonchNow/'><Icon name='facebook'/> Facebook</List.Item>
              <List.Item as='a' href='https://www.linkedin.com/company/lonch'><Icon name='linkedin'/> LinkedIn</List.Item>
            </List>
          </Grid.Column>

          <Grid.Column>
            <Header inverted as='h4' content='Legal' />
            <List link inverted>
              {
                menuItems.legal.map(i => 
                  <List.Item key={i.label} as={HashLink} smooth to={i.url}><Icon name={i.icon as SemanticICONS} /> {i.label}</List.Item>)
              }
            </List>            
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </Segment>


// WEBPACK FOOTER //
// ./src/common/Footer.tsx